// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 4_zYsp2QqoRZ
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicCreateChildUserPage.module.css"; // plasmic-import: 4_zYsp2QqoRZ/css

createPlasmicElementProxy;

export const PlasmicCreateChildUserPage__VariantProps = new Array();

export const PlasmicCreateChildUserPage__ArgProps = new Array("displayText");

const $$ = {};

function PlasmicCreateChildUserPage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__hEgzm)}>
            <div
              data-plasmic-name={"mainStack"}
              data-plasmic-override={overrides.mainStack}
              className={classNames(projectcss.all, sty.mainStack)}
            />

            <div className={classNames(projectcss.all, sty.freeBox__k2LDs)}>
              <div
                data-plasmic-name={"textStack"}
                data-plasmic-override={overrides.textStack}
                className={classNames(projectcss.all, sty.textStack)}
              >
                {renderPlasmicSlot({
                  defaultContents: "hunfa",
                  value: args.displayText,
                  className: classNames(sty.slotTargetDisplayText)
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "mainStack", "textStack"],
  mainStack: ["mainStack"],
  textStack: ["textStack"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCreateChildUserPage__ArgProps,
          internalVariantPropNames: PlasmicCreateChildUserPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCreateChildUserPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCreateChildUserPage";
  } else {
    func.displayName = `PlasmicCreateChildUserPage.${nodeName}`;
  }
  return func;
}

export const PlasmicCreateChildUserPage = Object.assign(
  // Top-level PlasmicCreateChildUserPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    mainStack: makeNodeComponent("mainStack"),
    textStack: makeNodeComponent("textStack"),
    // Metadata about props expected for PlasmicCreateChildUserPage
    internalVariantProps: PlasmicCreateChildUserPage__VariantProps,
    internalArgProps: PlasmicCreateChildUserPage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicCreateChildUserPage;
/* prettier-ignore-end */
